import { Container, ContainerGutter } from '@volkswagen-onehub/components-core';
import React from 'react';
import { HuchaDisclaimerTextLegal } from '../ui/hucha-disclaimer-text-legal';

interface DisclaimerContentProps {
	fontSize?: string;
	showDisclaimerNumber?: boolean;
	textGutter?: ContainerGutter;
}

export const HuchaDisclaimer2Content = ({
	fontSize,
	showDisclaimerNumber = true,
	textGutter = ContainerGutter.static350,
}: DisclaimerContentProps): React.JSX.Element => {
	return (
		<Container wrap={'always'} gutter={textGutter}>
			<HuchaDisclaimerTextLegal fontSize={fontSize}>
				{showDisclaimerNumber && '2. '}
				Bono-descuento de Marca de 1.000€ PVP válido exclusivamente para clientes particulares que: i) formalicen, antes
				del 31/12/2026, un pedido de un vehículo nuevo de la marca Volkswagen Turismos (aplicable a toda la gama
				Volkswagen de stock y pedidos a producción), ii) que en el momento de dicha formalización dispongan de un
				vehículo de la marca Volkswagen Turismos (aplicable a todos los modelos) matriculado entre el año 2011 y 2016 y
				iii) que estén debidamente registrados en el Club Volkswagen antes del 30/04/2026. Dicho bono-descuento se podrá
				descargar a través del portal del Club Volkswagen y deberá entregarse al Concesionario Oficial de su elección en
				el momento de realizar el pedido.
			</HuchaDisclaimerTextLegal>
			<HuchaDisclaimerTextLegal fontSize={fontSize}>
				Se trata de un bono-descuento nominal y no podrá canjearse por dinero en metálico ni para la compra de otros
				productos y/o servicios (por ejemplo, accesorios o servicios posventa, etc.). Sólo se aceptará un único cupón
				por compra y será válido una única vez. Acumulativo a otras promociones de la marca (excepto: Promociones
				Selectivas Web) y/o el Concesionario Oficial Volkswagen. El cupón no será acumulable a ofertas ni pedidos ya
				realizados por parte del Concesionario Oficial ni a cancelaciones de pedidos realizados antes del 15/02/2026.
			</HuchaDisclaimerTextLegal>
			<HuchaDisclaimerTextLegal fontSize={fontSize}>
				Contacta con tu Concesionario Oficial Volkswagen para que le informe de las condiciones específicas de la
				presente promoción así como de cualesquiera otras condiciones o descuentos adicionales que éste le pueda ofrecer
				y, en su caso, le elabore el correspondiente presupuesto u oferta personalizada.
			</HuchaDisclaimerTextLegal>
		</Container>
	);
};
